
import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
import { TranslateResult } from 'vue-i18n';

@Component
export default class VImageUpload extends Vue {
  @Prop({ type: Boolean, default: false }) public disabled?: boolean;
  @Prop({ type: Boolean, default: false }) public multiple?: boolean;
  @Prop({ type: Array, default: () => [] }) public errorMessages?: any[];
  @Prop({ type: String }) public name?: string | TranslateResult;
  @Prop({ type: String, default: 'image/*' }) public accept?: string;
  @Prop({ type: String }) public label?: string;
  @Prop({ type: String }) public hint?: string;
  @Prop({ type: Number }) public maxSize!: number;

  public $refs!: {
    fileInput: any;
  };

  public images: any = null;
  public showDialog: boolean = false;
  public isManualUpload: boolean = false;
  public showSingleImageAlert: boolean = false;
  public showNotAnImageAlert: boolean = false;
  public showFileSizeExceedAlert: boolean = false;

  public onInputClick(event: any) {
    if (!this.isManualUpload) {
      event.preventDefault();
      return (this.showDialog = true);
    }
  }

  public manualUpload() {
    this.isManualUpload = true;

    if (this.$refs?.fileInput?.$refs?.input) {
      this.$refs.fileInput.$refs.input.click();
    }

    this.isManualUpload = false;
  }

  public dragOver(event: any) {
    event.dataTransfer.dropEffect = 'copy';
  }

  public dragLeave(event: any) {
    event.dataTransfer.dropEffect = 'none';
  }

  public dropFile(event: any) {
    const droppedImages = event.dataTransfer.files;

    if (!droppedImages?.length) {
      return;
    }

    const imagesFiltered = this.filterImagesByAllowedSize(droppedImages);

    if (!this.testImages(droppedImages)) {
      this.showNotAnImageAlert = true;
      setTimeout(() => {
        this.showNotAnImageAlert = false;
      }, 1500);
      return;
    }

    if (!imagesFiltered?.length || imagesFiltered.length < droppedImages.length) {
      this.showFileSizeExceedAlert = true;
      setTimeout(() => {
        this.showFileSizeExceedAlert = false;

        if (this.multiple && imagesFiltered.length) {
          this.images = imagesFiltered;
        }
      }, 1500);
      return;
    }

    if (!this.multiple && droppedImages.length > 1) {
      this.showSingleImageAlert = true;
      setTimeout(() => {
        this.showSingleImageAlert = false;
      }, 1500);
      return;
    }

    this.images = this.multiple ? [...droppedImages] : droppedImages[0];
  }

  public testImages(files: any[]) {
    for (const file of files) {
      if (!file.type.match(this.accept)) {
        return false;
      }
    }
    return true;
  }

  public filterImagesByAllowedSize(files: any[]) {
    if (!this.maxSize) {
      return files;
    }

    const filesArr: any[] = [];

    for (const file of files) {
      filesArr.push(file);
    }

    const maxSize = this.maxSize * 1024 * 1024;

    return filesArr.filter((file) => file.size <= maxSize);
  }

  public emitData() {
    this.$emit('input', this.images);
    this.$emit('change', this.images);
  }

  @Watch('images')
  public onImagesChange() {
    if (!this.images) {
      this.emitData();
      return;
    }

    const imagesToTest = this.multiple ? this.images : [this.images];
    const imagesFiltered = this.filterImagesByAllowedSize(imagesToTest);

    if (!imagesFiltered?.length || imagesFiltered.length < imagesToTest.length) {
      this.showFileSizeExceedAlert = true;

      setTimeout(() => {
        this.showFileSizeExceedAlert = false;
        this.images = this.multiple && imagesFiltered.length ? imagesFiltered : null;
      }, 1500);

      return;
    }

    this.showDialog = false;
    this.emitData();
  }
}
